import React from 'react';
import ReactECharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

export const TotalPowerChart = ({ data, width = '600px' }) => {
  const colors = ['#A58EFF', '#FF7B7B', '#3FCED9'];
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  // Hàm format dữ liệu thành series
  const seriesNames = ['V out (L1)', 'V out (L2)', 'V out (L3)'];
  const formatToSeries = (arr) => {
    const phases = ['V(Phase L1)', 'V(Phase L2)', 'V(Phase L3)'];

    return phases.map((phase, index) => ({
      name: seriesNames[index], // Tên series
      type: 'bar',
      data: arr?.map((item) => item[phase]), // Lấy dữ liệu từng phase
      itemStyle: {
        color: colors[index], // Gán màu
      },
      label: {
        show: true,
        position: 'right',
        color: isAdminRoute,
      },
    }));
  };

  const series = formatToSeries(data);

  const option = {
    title: {
      text: 'V out',
      left: 'center',
      textStyle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#5470c6',
      },
    },
    legend: {
      data: seriesNames,
      bottom: '0',
      textStyle: {
        color: isAdminRoute,
      },
    },
    tooltip: {
      trigger: 'axis',
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '20%',
      top: '30%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisLabel: {
        formatter: '{value}',
        color: isAdminRoute,
      },
      axisLine: {
        lineStyle: {
          color: isAdminRoute,
        },
      },
    },
    yAxis: {
      type: 'category',
      data: ['Nguồn lưới 2', 'Nguồn lưới 1'], // Tên các dòng
      axisLine: {
        lineStyle: {
          color: isAdminRoute,
        },
      },
      axisLabel: {
        color: isAdminRoute,
      },
    },
    series: series,
  };
  return (
    <ReactECharts
      option={option}
      style={{ height: '250px' }}
      onEvents={() => {}}
    />
  );
};
